<template>
  <div>
    <v-layout>
      <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" v-on:input="$emit('updateDialog', false)" max-width="1200px">
        <v-card>
          <v-card-title>
            <span class="headline">
              Ruta N#{{ ruta.numTrip }}
            </span>
          </v-card-title>

          <v-card-text>
            <div>
              <v-data-table
                :headers="headersRemitos"
                :items="filteredRemitos"
                class="elevation-1 mt-5"
                v-model="selected"
                :loading="loading_remito"
                show-select
                :single-select="false"
                :disable-pagination="true"
                :hide-default-footer="true"
                :item-disabled="isItemDisabled"
              >
                <template v-slot:item="props">
                  <tr :class="{ 'grey lighten-3': isItemDisabled(props.item) }">
                    <td>
                      <v-checkbox 
                        :input-value="props.isSelected" 
                        style="margin:0px;padding:0px" 
                        hide-details 
                        @change="props.select($event)"
                        v-if="!isItemDisabled(props.item)"
                      />
                    </td>
                    <td>{{ props.item.orden }}</td>
                    <td>{{ props.item.remito }}</td>
                    <td>{{ props.item.isCharge ? "Carga":"Descarga" }}</td>
                    <td>{{ props.item.client.nameClient }}</td>
                    <td>{{ props.item.subClient.nameSubClient }}</td>
                    <td>
                      <GeoIndicator :subClient="props.item.subClient" />
                      {{ props.item.subClient.subClientAddress != null ? props.item.subClient.subClientAddress : "" }}
                    </td>
                    <td>{{ props.item.pallets }}</td>
                    <td>{{ props.item.packages }}</td>
                    <td>{{ props.item.kg }}</td>
                    <td>{{ props.item.cubicMeters }}</td>

                    <td
                      style="min-width:135px"
                      v-html="getState(props.item, props)"
                      :title="
                        props.item.closed == true && props.item.delivered != null ? new Date(props.item.delivered).toISOString().substr(0, 10) + ' | ' + getHora(new Date(props.item.delivered)) : ''
                      "
                    ></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn 
              color="success" 
              text 
              v-show="formBtn != '' && formBtn != 'Crear'" 
              @click="mode === 'select' ? generateReport() : handleDelivery()"
              :disabled="selected.length === 0"
              :loading="loading_submit_remito"
            >
              {{ formBtn }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { rutasService } from "@/libs/ws/rutasService";
import { remitosService } from "@/libs/ws/remitosService";
import GeoIndicator from "@/components/GeoIndicator.vue";

export default {
  props: {
    modal_title: String,
    dialog: Boolean,
    button_name: String,
    formBtn: String,
    ruta: Object,
    selectedRemitos: Function,
    mode: {
      type: String,
      default: 'select', // 'select' o 'deliver'
      validator: value => ['select', 'deliver'].includes(value)
    },
    deliveryAction: Function, 
  },
  components: { GeoIndicator },
  data() {
    return {
      reportGenerate: false,
      selected: [],
      show: false,
      clients: [],
      subclients: [],
      loading_subclientes: false,
      search: " ",
      headersRemitos: [
        {
          text: "Orden",
          align: "left",
          sortable: true,
          value: "Orden",
          class: "lighten-2",
        },
        {
          text: "N° Remito",
          align: "left",
          sortable: true,
          value: "Remito",
          class: "lighten-2",
        },{
          text: "Tipo de Remito",
          align: "left",
          sortable: true,
          value: "isCharge",
          class: "lighten-2",
        },
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "clients.nameClient",
          class: "lighten-2",
        },
        {
          text: "Sub Cliente",
          align: "left",
          sortable: true,
          value: "subclients.nameSubClient",
          class: "lighten-2",
        },
        {
          text: "Direccion",
          align: "left",
          sortable: true,
          value: "subclients.subClientAddress",
          class: "lighten-2",
        },
        {
          text: "Pallets",
          align: "left",
          sortable: true,
          value: "pallets",
          class: "lighten-2",
        },
        {
          text: "Bultos",
          align: "left",
          sortable: true,
          value: "packages",
          class: "lighten-2",
        },
        {
          text: "KG",
          align: "left",
          sortable: true,
          value: "kg",
          class: "lighten-2",
        },
        {
          text: "M3",
          align: "left",
          sortable: true,
          value: "m3",
          class: "lighten-2",
        },
        {
          text: "Estado",
          align: "left",
          sortable: true,
          value: "state",
          class: "lighten-2",
        },
      ],
      loading_remito: false,
      loading_submit_remito: false
    };
  },
  computed: {
    filteredRemitos() {
      if (!this.ruta || !this.ruta.delivered) return [];
      return this.ruta.delivered;
    }
  },
  watch: {
    dialog() {
      this.errors.clear();
      if (this.mode === 'select') {
        this.selected = this.ruta.delivered;
      } else {
        this.selected = [];
      }
      this.getRemitos(this.ruta.id);
    },
  },
  mounted() {
    if (this.ruta != null) {
      if (this.mode === 'select') {
        this.selected = this.ruta.delivered;
      } else {
        this.selected = [];
      }
      this.getRemitos(this.ruta.id);
    }
  },

  methods: {
    isItemDisabled(item) {
      if (this.mode === 'deliver') {
        return item.estate && (
          item.estate.id === remitosService.ENTREGADO || 
          item.estate.id === remitosService.NO_ENTREGADO
        );
      }
      return false;
    },
    getRemitos(id) {
      if (!id || id === undefined || id === null) {
        console.error("ID is required for getRutaWithRemitos");
        return;
      }
      this.loading_remito = true;
      rutasService
        .getRutaWithRemitos(id)
        .then((response) => {
          this.ruta.delivered = response.delivered;
          if (this.mode === 'select') {
            this.selected = response.delivered;
          } else {
            this.selected = this.selected || [];
          }
          this.loading_remito = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading_remito = false;
        });
    },
    getHora(date) {
      const tempMinutes = date.getMinutes();
      const minutes = tempMinutes < 10 ? `0${tempMinutes}` : tempMinutes;
      var hora = date.getHours() + ":" + minutes;
      return hora;
    },
    getState(item, ruta) {
      if (item.closed == true) {
        if (item.delivered != null) {
          return '<p class="state_entregado">Entregado</p>';
        } else {
          return '<p class="state_no_entregado">No Entregado</p>';
        }
      } else {
        if (ruta != null && ruta.initialDate == null) {
          return '<p class="state_en_espera">En espera</p>';
        }
        return '<p class="state_en_camino">En camino</p>';
      }
    },
    generateReport() {
      this.$emit("selectedRemitos", this.selected);
      this.$emit("updateDialog", false);
    },
    handleDelivery() {
      if (this.selected.length === 0) {
        this.$toast?.error("Debe seleccionar al menos un remito para entregar");
        return;
      }

      this.loading_submit_remito = true;
      const payload = {
        Remitos: this.selected.filter(remito => !this.isItemDisabled(remito)).map(remito => ({
          Id: remito.id
        }))
      };


      remitosService
        .entregarRemitoMasivamente(payload)
        .then((response) => {

          if(response != '' && response.status == 200) {
          
            console.log('Remitos entregados masivamente:', response);
            this.$toast?.success(response.title);
            this.$emit("updateDialog", false);
            this.deliveryAction(this.selected);
          } else {
            this.$toast?.error("Ocurrió un error al entregar los remitos");
          }

        })
        .catch((error) => {
          console.error('Error al entregar remitos masivamente:', error);
          this.$toast?.error("Ocurrió un error al entregar los remitos");
        })
        .finally(() => {
          this.loading_submit_remito = false;
        });
    },
  },
};
</script>
